@if (loading() || isError() || noRequests()) {
  <div class="flex size-full flex-col">
    <div class="m-auto">
      @if (loading()) {
        <sb-loading-state />
      } @else if (isError()) {
        <sb-empty-state [icon]="'warning-regular'" [description]="'Oops, something went wrong' | translate">
          <button sb-button color="secondary" (click)="retryInitialLoad()">{{ 'Retry' | translate }}</button>
        </sb-empty-state>
      } @else {
        <sb-empty-state [icon]="'clipboard-regular'" [description]="'No requests have been found' | translate" />
      }
    </div>
  </div>
} @else {
  <ng-container *subscriptionPlan="planType.BASIC">
    <exchange-requests
      [exchanges]="incomingExchanges()"
      [title]="'Incoming Exchanges' | translate"
      [context]="exchangeRequestContext.INCOMING"
      [showAvatars]="true"
      [showIndicator]="true"
    />
    <exchange-requests [exchanges]="outgoingExchanges()" [title]="'Outgoing Exchanges' | translate" />
    <open-shifts [openShifts]="openShifts()" />
    <absence-request-notifications [absences]="pendingAbsences()" [isOwnAbsences]="true" />
    <requests-paging-status
      [hasMore]="hasMore()"
      [loading]="loading()"
      [loadingMore]="loadingMore()"
      [loadMoreFailed]="loadMoreFailed()"
      (loadMore)="retryLoadMore()"
      (retry)="retryLoadMore()"
    />
  </ng-container>
}
